import { createStyles } from "@mantine/core";
import { breakpoints, colors, pxToRem } from "theme";

import { PhotoGridProps } from "../PhotoGrid/PhotoGrid";

type CreateStylesProp = {
  gridGap?: PhotoGridProps["gridGap"];
};

export const useStyles = createStyles((_theme, { gridGap = pxToRem[12] }: CreateStylesProp) => ({
  singlePhotoGrid: {
    display: "flex",
    gap: "unset",
  },
  photoGridDocuments: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: gridGap,
    width: "100%",
    position: "relative",
  },
  documentContainer: {
    minHeight: "154px",
    maxHeight: "154px",
    width: "100%",
    position: "relative",
    justifySelf: "center",
    flex: "1",
    "&:nth-of-type(2n)": {
      justifySelf: "flex-start",
    },
    backgroundColor: "#F5F6F7",
    border: "1px solid #DADFE3",
    borderRadius: "7px",
    overflow: "hidden",
    [`${breakpoints.mobileLg}`]: {
      minHeight: "354px",
    },
  },
  document: {
    width: "100%",
    height: "auto",
    display: "flex",
    margin: "auto",
  },
  deleteImageIcon: {
    borderRadius: "50%",
    padding: "7px",
    height: pxToRem[32],
    width: pxToRem[32],
    backgroundColor: colors.red[5],
    position: "absolute",
    top: pxToRem[12],
    right: pxToRem[12],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
  caption: {
    minHeight: "50px",
  },
}));
